
import './fullScreenModalSuccess.scss';

export default function hpFullScreenModalSuccess() {
    return {
        restrict: 'E',
        scope: {
            primaryText: '@',
            secondaryText: '@',
            contentList: '=',
            proTipText: '@',
            buttonText: '@',
            buttonFn: '&',
        },
        templateUrl: 'app/common/fullScreenModalSuccess/fullScreenModalSuccess.html',
    };
}



// WEBPACK FOOTER //
// ./src/app/common/fullScreenModalSuccess/hpFullScreenModalSuccess.js